import React from 'react';
import { createRoot } from 'react-dom/client';
import { initTracker } from '../../utils/fast';
import { erudaInitTest } from '../../utils';
import App from './app';

initTracker();
erudaInitTest();

const render = () => {
  const container = document.getElementById('root');
  const root = createRoot(container as HTMLElement);
  root.render(<App />);
};

render();
